import React from "react";
import ReactApexChart from "react-apexcharts";

export default function MultiChart({ label, title, yTitle, series }) {

  let options = {
    chart: {
      type: 'area',
      stacked: false,
    },
    stroke: {     //tickness of lines
      width: [6, 6, 6, 6]
    },
    title: {
      text: title
    },
    labels: label,
    dataLabels: {
      enabled: false,
    },
    yaxis: {
      title: {
        text: yTitle + ' in 1,000,000$',
      },
      labels: {
        formatter: function (val) {
          return (val / 1000000).toFixed(2);
        },
      }
    },
    tooltip: {
      shared: true,
      intersect: false,
      y: {
        formatter: function (y) {
          if(typeof y !== "undefined") {
            return  y.toFixed(2) + " $";
          }
          return y;
        }
      }
    }
  };

  return (
    <ReactApexChart options={options} series={series} type="area" width={800} />
  );
  
}